module.exports = fox._r("images/valentines/gift-12.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines/gift-12.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines/gift-12.png
// module id = 236
// module chunks = 4